jQuery(function ($) {
    $('.dm-toggle').on('click', function(e){
    e.preventDefault();
    $('body').toggleClass('menu-is-active');  
  });

    document.querySelectorAll('.dm-dossier').forEach((dossier) => {
      document.addEventListener('click', (event) => {
        if (!dossier.contains(event.target)) dossier.open = false;
      });

      document.addEventListener('focusin', (event) => {
        if (!dossier.contains(event.target)) dossier.open = false;
      });

      dossier.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && dossier.open) {
          event.preventDefault();
          dossier.open = false;
          dossier.querySelector('summary').focus();
        }
      });
    });

    const $imageSlider = $('.js-image-slider');

    // Init Owl Carousel
    $imageSlider.owlCarousel({
      loop: true,
      nav: false,
      margin: 0,
      autoplay: true,
      dots: false,
      items: 1
    });

    const $testimonialsSlider = $('.js-testimonials');

    // Init Owl Carousel
    $testimonialsSlider.owlCarousel({
      loop: true,
      nav: true,
      margin: 40,
      stagePadding: 10,
      autoplay: true,
      dots: false,
      items: 2,
      center: true,
      responsive: {
        0: {
          items: 1,
          margin: 20
        },
        768: {
          items: 2,
          margin: 40
        }
      }
    });

    const $partnerSlider = $('.js-partner-slider');

    // Init Owl Carousel
    $partnerSlider.owlCarousel({
      loop: true,
      nav: false,
      margin: 30,
      autoplay: true,
      autoplayTimeout: 5000, // geen wachttijd tussen bewegingen
      autoplaySpeed: 5000, // bepaalt de snelheid van de beweging
      autoplayHoverPause: false,
      slideTransition: 'linear', // zorgt voor een vloeiende, constante beweging
      dots: true,
      items: 4,
      responsive: {
        0: {
          items: 2,
          margin: 20
        },
        768 : {
          items :3,
          margin: 30
        },
        992 : {
          items: 4
        },
        1200 : {
          items: 5
        }
      }
    });

    $('a[href^="#"]').on('click', function(e) {
      e.preventDefault();

      const target = $($(this).attr('href'));
      const offset = 160; // hoogte van je vaste navbar
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - offset
        }, 600);
      }
    });

});

(function(){
  const body = document.body;
  const SCROLL_POINT = 80; // pixels scroll before shrink
  let isScrolled = false;

  function onScroll(){
    if(window.scrollY > SCROLL_POINT && !isScrolled){
      body.classList.add('is-scrolled');
      isScrolled = true;
    } else if(window.scrollY <= SCROLL_POINT && isScrolled){
      body.classList.remove('is-scrolled');
      isScrolled = false;
    }
  }

  document.addEventListener('scroll', onScroll, { passive: true });

// Detect scroll direction after passing 350px
let lastScroll = 0;
const scrollThreshold = 350;
const bottomOffset = 200;


window.addEventListener('scroll', () => {
  const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
  const viewportHeight = window.innerHeight;
  const documentHeight = document.documentElement.scrollHeight;

  // Check if near bottom of page
  const nearBottom = (currentScroll + viewportHeight + bottomOffset >= documentHeight);

  // Remove classes if we're near the bottom
  if (nearBottom) {
    body.classList.remove('scrolling-up', 'scrolling-down');
    lastScroll = currentScroll;
    return;
  }

  // Remove classes if we're near the top
  if (currentScroll <= scrollThreshold) {
    body.classList.remove('scrolling-up', 'scrolling-down');
    lastScroll = currentScroll;
    return;
  }

  // Scrolling down
  if (currentScroll > lastScroll && !body.classList.contains('scrolling-down')) {
    body.classList.remove('scrolling-up');
    body.classList.add('scrolling-down');
  }

  // Scrolling up
  else if (currentScroll < lastScroll && !body.classList.contains('scrolling-up')) {
    body.classList.remove('scrolling-down');
    body.classList.add('scrolling-up');
  }

  lastScroll = currentScroll;
});



  // Visible Observer
  document.addEventListener("DOMContentLoaded", () => {
    const blocks = document.querySelectorAll(".dm-block");

    const options = {
      root: null, // viewport
      rootMargin: "0px 0px -10%",
      threshold: 0 // 10% zichtbaar = trigger
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
        } else {
          entry.target.classList.remove("is-visible");
        }
      });
    }, options);

      blocks.forEach(block => observer.observe(block));
  });

  // Google Maps
    const mapMarker = document.getElementById("marker");

    if (typeof(mapMarker) != 'undefined' && mapMarker != null) {
      
      (g => { var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window; b = b[c] || (b[c] = {}); var d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams, u = () => h || (h = new Promise(async (f, n) => { await (a = m.createElement("script")); e.set("libraries", [...r] + ""); for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]); e.set("callback", c + ".maps." + q); a.src = `https://maps.${c}apis.com/maps/api/js?` + e; d[q] = f; a.onerror = () => h = n(Error(p + " could not load.")); a.nonce = m.querySelector("script[nonce]")?.nonce || ""; m.head.append(a) })); d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)) })({
        key: "AIzaSyBt2_JwEXvGGynnKUQlqmiGbaM6TKeDYxs",
        v: "weekly",
        // Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
        // Add other bootstrap parameters as needed, using camel case.
      });

      // Get all data
      const global = document.querySelector("#marker");

      // Get Latitude & Longitude
      const global_lat = +global.dataset.lat;
      const global_lng = +global.dataset.lng;

      const mapCenter = { lat: global_lat, lng: global_lng };

      // Get zoom level
      const zoom = +global.dataset.zoom;

      // Get Map ID -> https://console.cloud.google.com/google/maps-apis/studio/maps?project=dev-metal-maps
      const mapId = global.dataset.mapid;

      // Hide User Interface
      const hideUI = global.dataset.ui;

      // Get infoWindow content
      const infoWindowContent = global.dataset.content

      // Get marker icon url
      const iconUrl = global.dataset.iconurl;

      let map;

      async function initMap() {
        const { Map } = await google.maps.importLibrary("maps");
        map = new Map(document.getElementById("map"), {
          mapId: mapId,
          center: mapCenter,
          zoom: zoom,
          disableDefaultUI: hideUI,
        });
        const contentString =
          '<div id="content" class="dm-maps-infowindow" style="min-width:200px;">' +
          infoWindowContent +
          "</div>";
        const infowindow = new google.maps.InfoWindow({
          content: contentString,
          ariaLabel: "",
        });

        const icon = {
          url: iconUrl,
          scaledSize: new google.maps.Size(70, 93),
        };

        const marker = new google.maps.Marker({
          position: mapCenter,
          icon: icon,
          map,
          title: "Title",
        });

        marker.addListener("click", () => {
          infowindow.open({
            anchor: marker,
            map,
          });
        });
      }

      initMap();

    }

})();
